export default "__VITE_ASSET__DHz__kJJ__"